import { defineStore } from 'pinia'
import { ref, watchEffect } from 'vue'
import { useLoadCabinetAdminConfigurator } from './api'
import type { AdminConfiguratorEventsType, AdminConfiguratorType } from './../model/types'
import { useTranslate } from '@/shared/lib'

const useModelTable = defineStore('cabinet_admin_config_table', () => {
  const { trs } = useTranslate()

  const configs = ref<AdminConfiguratorType[]>([])
  const events = ref<AdminConfiguratorEventsType[]>([])

  /**
   * Настройки шапки формы
   */
  const headers = ref([
    { title: '№', key: 'index', sortable: false },
    { title: trs('itf.pin_number'), key: 'pin_number' },
    { title: trs('itf.value'), key: 'value', sortable: false },
    {
      title: trs('itf.type'),
      key: 'device_event_type_id',
      sortable: false,
      value: (item: AdminConfiguratorType) => {
        return (
          events.value.find((event) => event.id == item.device_event_type_id)?.event_type ||
          'Не задан'
        )
      },
    },
    { title: trs('itf.description'), key: 'description', sortable: false },
    { title: trs('itf.control'), key: 'action', sortable: false },
  ])

  const loadTable = () => {
    const result = useLoadCabinetAdminConfigurator()

    watchEffect(() => {
      if (result.data.value) {
        configs.value = result.data.value.data
        events.value = result.data.value.payload.events
      }
    })

    return result
  }

  return {
    configs,
    events,
    headers,

    loadTable,
  }
})

export { useModelTable }
